// 
// ContentReadiness.js
// cenit-website
// 
// Created by Matías Martínez on 22/8/25
// 

class ContentReadiness {
  
  async waitForImagesInElement(container){
    const images = Array.from(container.querySelectorAll("img"));
    
    // Bridge with a Promise for each image
    const promises = images.map(img => {
      if (img.complete) {
        return Promise.resolve();
      } else if (img.decode) {
        // Modern browsers
        return img.decode().catch(() => {}); // swallow errors (broken images)
      } else {
        // Fallback for older browsers
        return new Promise(resolve => {
          img.addEventListener("load", resolve, { once: true });
          img.addEventListener("error", resolve, { once: true });
        });
      }
    });
    
    await Promise.all(promises);
  }
  
  async waitForAnimationsInElement(element) {
    if ("getAnimations" in element) {
      const activeAnimations = element.getAnimations({ subtree: true });
  
      if (activeAnimations.length === 0) {
        return;
      }
      
      console.log(activeAnimations);
  
      const animationPromises = activeAnimations.map(animation => animation.finished.catch(() => {}));
      await Promise.all(animationPromises);
    } else {
      // Fallback: wait a fixed delay
      await this.fixedDelay(seconds);
    }
  }
  
  async waitForFixedDelay(seconds){
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
  }
  
  async waitForAllFonts(){
    // https://gomakethings.com/a-modern-font-loading-strategy-with-the-vanilla-js-fontfaceset.load-method/
    // Fast-path if cookie was set:
    const fastPathCookieName = "fontsLoaded";
    const fastPathEnabled = false;
    
    if (this.readCookie(fastPathCookieName) && fastPathEnabled) {
      return;
    }
    
    if (!("fonts" in document)) {
      return;
    }
    
    // Built-in promise:
    await document.fonts.ready;
    
    const expires = new Date(+new Date() + (7 * 24 * 60 * 60 * 1000));
    this.writeCookie(fastPathCookieName, true, expires);
  }
  
  readCookie(name){
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }
  
  writeCookie(name, value, expires){
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}`
  }
  
}

export default ContentReadiness;
